

class FlashSaleTimer extends HTMLElement {
    constructor() {
        super();

        this.endTime = parseInt(this.dataset.endTime) * 1000;
        this.intervalId = null;
        this.init();
    }

    init() {
        this.updateTimer();
        this.intervalId = setInterval(() => this.updateTimer(), 1000);
    }

    updateTimer() {
        const now = Date.now();
        const remaining = this.endTime && !isNaN(this.endTime) ? this.endTime - now : 0;

        if (remaining <= 0) {
            if (this.dataset.editorPreviewMode !== 'true') {
                this.closest('.badge--promotion-text').style.display = 'none';
            }
            
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            return;
        }

        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

        const daysEl = this.querySelector('[data-days]');
        const hoursEl = this.querySelector('[data-hours]');
        const minutesEl = this.querySelector('[data-minutes]');
        const secondsEl = this.querySelector('[data-seconds]');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    disconnectedCallback() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
}

if (!customElements.get('flash-sale-timer')) {
    customElements.define('flash-sale-timer', FlashSaleTimer);
}